// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alignPhoto[data-v-3740b705] {\n  margin-top: -28px !important;\n}\n.alignPhoto .title-on-border[data-v-3740b705] {\n  padding: 1px;\n}", ""]);
// Exports
module.exports = exports;
